'use client';

import { ClientOnlyLoader } from '../../shared/ClientOnlyLoader';
import { Skeleton } from '@/components/ui/skeleton';

export const CategoriesCarousel = (props) => (
  <ClientOnlyLoader
    load={() => import('./CategoriesCarousel.client.tsx').then((m) => m.CategoriesCarouselClient)}
    fallback={<Skeleton className='w-full h-[120px]' />}
    props={props}
  />
);
